import "./ScrollArrow.css";

const ScrollArrow = () => {
  return (
    <a href="#bio">
      <div className="container">
        <div className="chevron"></div>
        <div className="chevron"></div>
        <div className="chevron"></div>
      </div>
    </a>
  );
};

export default ScrollArrow;
